module.exports = __webpack_public_path__ + "img/interface OneB Player_1.e21cda0b.jpg";